<template>
    <div class="upload" @click.stop="" :style="{width:(sizeObj?sizeObj.width:100)+ 'px',height:(sizeObj?sizeObj.height:100)+ 'px'}">
        <div class="imgbox" v-if="imglist.length" v-for="v,i in imglist" @click="uploadType='change';operateIndex=i" :key="i">
            <img :src="imgUrl+v" alt="" >
            <div class="mask" v-if="!disabled">
                <Icon type="trash-a" class="iconFont" @click.native="deleteImg()"></Icon>
                <div class="editImg">
                    <Upload  class="editImg_upload"
                        ref="upload"
                        :show-upload-list="false"
                        :on-success="handleSuccess"
                        :format="['jpg','jpeg','png','gif','svg']"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :action="imgApi"
                        name='image'
                        :max-size='imgsize'
                        >
                        <div>
                            <Icon type="compose" class="iconFont" ></Icon>
                        </div>
                    </Upload>
                </div>
            </div>
        </div>
        <div @click="uploadType='add'"  v-if="!disabled">
            <Upload v-if="imglist.length<imglength"
                class="uploadUi"
                ref="upload"
                :show-upload-list="false"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png','gif','svg']"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :multiple="multipleFlag?true:false"
                type="drag"
                :action="imgApi"
                name='image'
                :max-size='imgsize'>
                <div style="line-height:100px">
                    <Icon type="plus-round" size='20'></Icon>
                </div>
                 <!-- <div style="width: 240px; height: 100px; line-height: 100px;">
                    <Icon type="camera" size="20"></Icon>
                </div> -->
            </Upload>
        </div>
    </div>
</template>
<script>
import AES from '@/common/js/AES.js'

    export default {
        props:["imgSize","imgList",'imgLength','multipleFlag',"disabled",'size'],
        data(){
            return {
                sizeObj:'',//宽高对象
                imgsize:'',//图片尺寸
                imglist:[],//图片列表
                imglength:1,
                uploadType:'',/* 上传的类型 */
                operateIndex:'',/* 删除 、 替换图片的下标 */
            }
        },
        methods:{
            lookImg(img){
                this.imgPreview.img=img;
                this.imgPreview.flag=true
            },
            handleFormatError(){
                this.$Message.error('图片上传失败')
            },
            handleMaxSize(){
                this.$Message.error('图片大小超出限制')
            },
            handleSuccess(res,file){
                console.log(AES.decrypt(res))
                // res = JSON.parse(AES.decrypt(res))
                if(res.code=='200'){
                    // this.$Message.success('操作成功')
                    this.uploadType=='add'?this.imglist.push(res.data):this.imglist.splice(this.operateIndex,1,res.data)
                    
                    this.$emit('uploadSuccess',this.imglist);
                }else{
                    this.$Message.error(res.message);
                }
            },
            deleteImg(){
                this.$nextTick(()=>{
                    this.imglist.splice(this.operateIndex,1);
                    this.$emit('uploadSuccess',this.imglist);
                })
            }
        },
        created(){
            this.imgsize=this.imgSize?this.imgSize:1024;
            this.imglist=this.imgList?this.imgList:[]
            this.imglength=this.imgLength?this.imgLength:1
            this.sizeObj = this.size?this.size:''
            console.log(this.sizeObj )
        },
        mounted(){
           
        },
        watch:{
            imgList:{
                handler:function(val,oldval){
                    this.imglist=this.imgList?this.imgList:[]
                }
            },
            deep:true
        }
    }
</script>
<style>
    .editImg_upload .ivu-upload-drag{
        border: none;
        background: none;
        line-height: 100px;
    }
    .uploadUi .ivu-upload-drag{
        width: 100%;
        height: 100%;
    }
</style>
<style scoped>
    .uploadUi{
        min-width: 100px;
        height: 100px;
    }
    .upload{
        flex-wrap: wrap;
        display: flex;
    }
    .imgbox{
        width: 100%;
        height: 100%;
        position: relative;
        margin-right: 10px;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
    }
    .editImg{
        display: inline-block;
        vertical-align: middle;
    }
    .imgbox img{
        width: 100%;
        height: 100%;
        display: inline-block;  
    }
    .mask{
        width: 100%;
        height: 100%;
        position: absolute;
        left:0;top: 0;
        background: rgba(0,0,0,0.5);
        /* display: none; */
        cursor: pointer;
        text-align: center;
        line-height: 60px;
        border-radius: 4px;
    }
    .imgbox:hover .mask{
        display: block;
    }
    .deleteIcon{
        color: #fff;
        font-size: 20px;
        text-align: center;
    }
    .deleteUnable{
        display: none;
    }
    .iconFont{
        font-size: 20px;
        color: #fff;
    }

</style>

